import type { $Fetch } from 'ofetch';
import type { Aluno } from '@/domain/model/Aluno';
import type { AlunoStatusHistorico } from '@/domain/model/AlunoStatusHistorico';
import type {
  AlterarStatusCommand, AlunoStatusGateway,
} from '@/application/port/out/AlunoStatusGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpAlunoStatusGateway implements AlunoStatusGateway {
  constructor(private readonly client: $Fetch) {}

  async alterar(command: AlterarStatusCommand): Promise<Aluno> {
    const res = await this.client<ApiResponse<Aluno>>(
      `/api/v1/alunos/${encodeURIComponent(command.alunoId)}/status`,
      { method: 'PATCH', body: { statusNovo: command.statusNovo, motivo: command.motivo } });
    assertApiSuccess(res);
    return res.data;
  }

  async listHistorico(alunoId: string): Promise<AlunoStatusHistorico[]> {
    const res = await this.client<ApiResponse<AlunoStatusHistorico[]>>(
      `/api/v1/alunos/${encodeURIComponent(alunoId)}/status-historico`,
      { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }
}
